var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconChevronLeft = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4 12L15.7 6.7C16.1 6.3 16.1 5.7 15.7 5.3C15.3 4.9 14.7 4.9 14.3 5.3L8.3 11.3C7.9 11.7 7.9 12.3 8.3 12.7L14.3 18.7C14.5 18.9 14.8 19 15 19C15.2 19 15.5 18.9 15.7 18.7C16.1 18.3 16.1 17.7 15.7 17.3L10.4 12Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconChevronLeft);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "media/IconChevronLeft.fc08136e34994a8d0c1075c1e9d8a417.svg";